'use client';

import { ButtonV1, ContentErrorView } from '@northladder/design-system';
import { useTranslations } from '@northladder/i18n';

interface IErrorInFetchingListProps {
  /**
   * Calls the API to reload the list from the session info.
   * Will again fail if the session expired.
   */
  onRetry: () => void;
  /**
   * Restart the journey
   */
  onRestart: () => void;
}

/**
 * -----------------------------------------------------------------------------
 * UI shown when the user app fails to validate the session due to an invalid /
 * expired evaluation id or a failed network call.
 */
export function ErrorInValidatingSession({
  onRetry,
  onRestart,
}: IErrorInFetchingListProps) {
  const t = useTranslations('ErrorInValidatingEvaluation');

  return (
    <ContentErrorView subTitle={t('subTitle')} title={t('title')}>
      <div className="flex w-full justify-end">
        <ButtonV1
          className="mx-auto my-4 w-auto px-16"
          isEnabled
          isLoading={false}
          label={t('reTry')}
          onClick={onRetry}
          type="button"
        />
      </div>
      <div className="py-4 text-sm font-light text-gray-500">
        {t('beginAfresh')}

        <button
          className="form-link-action ms-2"
          onClick={onRestart}
          type="button"
        >
          {t('restartAssessment')}
        </button>
      </div>
    </ContentErrorView>
  );
}
